const teamBtns = document.querySelectorAll('.team__cards-wrapper');

const teamToggle = () => {
    teamBtns.forEach(team => {
        team && team.addEventListener('click', (e) => {
            if(e.target.classList.contains('team-card__btn')) {
                e.target.classList.toggle('active');
            }
        })
    })
}

window.addEventListener('load', () => teamToggle());